module.exports = __webpack_public_path__ + "static/media/sync+hover.e8235061.svg";